import React from 'react';
import TWEEN from '@tweenjs/tween.js';
import redrawCanvas from './canvas/redrawCanvas';
import componentDidUpdate from './componentDidUpdate';
import render from './canvas/render';
import { createHiDPICanvas } from './canvas/createHiDPICanvas';
import removeBall from './ballFunctions/removeBall';
import addBall from './ballFunctions/addBall';

import { createAllPins } from '../board/CreateAllPins';

var bezierScene = null;

class BezierScene extends React.Component {
  canvas = null;
  ctx = null;
  constructor(props) {
    super(props);
    this.state = {
      rows: this.props.rows,
      risk: this.props.risk,
      board: createAllPins(this.props.rows, 315),
      lastPath: [],
      coeffs: this.props.coeffs,
      wheelCoefs: this.props.wheelCoefs,
    };
    this.addBall = addBall.bind(this);
    this.removeBall = removeBall.bind(this);
    this.redrawCanvas = redrawCanvas.bind(this);
    this.render = render.bind(this);
    this.componentDidUpdate = componentDidUpdate.bind(this);
  }

  balls = [];

  componentDidMount() {
    bezierScene = this;
    this.canvas = createHiDPICanvas(315, 375, 4);
    this.ctx = this.canvas.getContext('2d');
    this.redrawCanvas();
  }
}
export default BezierScene;

function animate(time) {
  requestAnimationFrame(animate);
  TWEEN.update(time);
  if (bezierScene != null) {
    bezierScene.redrawCanvas();
  }
}
requestAnimationFrame(animate);
